import React from "react";
export function GridBackdrop() {
  return <div className="pointer-events-none fixed inset-0 z-0 hidden md:block" aria-hidden="true" data-id="element-214" data-mp="2lk66wizhykj8">
      <div className="page-container grid h-full grid-cols-4 lg:grid-cols-12" data-id="element-215" data-mp="tvqj0ug4qr3e">
        {Array.from({
        length: 12
      }).map((_, i) => <div key={i} className={`border-l border-gridline ${i >= 4 ? "hidden lg:block" : ""} ${i === 3 ? "border-r lg:border-r-0" : ""} ${i === 11 ? "lg:border-r" : ""}`} data-id="element-216" data-mp="12ullpwjytj1y" data-mpi={i} />)}
      </div>
    </div>;
}